module.exports = __webpack_public_path__ + "static/media/g-5.088e9aaa.jpg";